import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError, genericSuccess } from '@/utils/alerts.service';
import { fileUpload } from '@/store/vendorDashboard/modules/fileUpload';

export const branding = {
  namespaced: true,
  state: {
    branding: {},
  },
  getters: {
    branding(state) {
      return state.branding;
    },
  },
  mutations: {
    setBranding(state, data) {
      state.branding = data;
    },

    updateBranding(state, payload) {
      state.branding[payload.key] = payload.value;
    },

    setImage(state, payload) {
      state.branding[payload.field] = payload.uri;
    },
  },
  actions: {
    ...fileUpload.actions,

    setDirtyTab({ commit }) {
      commit('settings/addDirtyTab', 'branding', { root: true });
    },

    async fetchBranding({ dispatch, commit }) {
      return vendorDashboardAPI
        .getBranding()
        .then(data => {
          commit('setBranding', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async saveBranding({ dispatch, state }) {
      return vendorDashboardAPI
        .saveBranding(state.branding)
        .then(() => {
          dispatch('showUserMessage', { ...genericSuccess }, { root: true });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    brandingChange({ commit }, payload) {
      commit('updateBranding', payload);
      commit('settings/addDirtyTab', 'branding', { root: true });
    },
  },
};
